import { apiClient } from '@/services/apiClient';
import type { AuthResponse, User } from '@/types';

interface LoginPayload {
  username: string;
  password: string;
}

export const login = async (data: LoginPayload) => {
  const response = await apiClient.post<AuthResponse>('/auth/login', data);
  return response.data;
};

export const register = async (payload: {
  username: string;
  password: string;
  fullName: string;
  email?: string;
}) => {
  const response = await apiClient.post<{ user: User }>('/auth/register', payload);
  return response.data.user;
};

export const refreshToken = async (refreshTokenValue: string) => {
  const response = await apiClient.post<AuthResponse>('/auth/refresh', {
    refreshToken: refreshTokenValue,
  });
  return response.data;
};

export const fetchCurrentUser = async () => {
  const response = await apiClient.get<{ user: User }>('/auth/me');
  return response.data.user;
};

export const updateProfile = async (payload: { fullName?: string; email?: string | null }) => {
  const response = await apiClient.put<{ user: User }>('/auth/profile', payload);
  return response.data.user;
};

export const changePassword = async (payload: { currentPassword: string; newPassword: string }) => {
  const response = await apiClient.put<{ message: string }>('/auth/password', payload);
  return response.data;
};
